import {useGroupAuthorize} from '@/hooks/useAuth';
import {useEntitledForClient} from '@/hooks/useEntitlements';

import {workTimeTrackingGroups} from '../utils/workTimeGroups';

export const useCanTrackWorkTime = () => {
  const isWorkTimeGroup = useGroupAuthorize(workTimeTrackingGroups);
  const isWorkTimeEntitled = useEntitledForClient('WORK_TIME');

  return isWorkTimeGroup && isWorkTimeEntitled;
};
